import ConfigService from './configurationService.js';
import Base64 from './base64.js';
import util from './nuskin.util.js';
import * as firebase from 'firebase';

const CONFIG = {
    prod: {
        apiKey: "AIzaSyBrHFBKi6OTY_ygW7_Zt9Qf8vpBYjZQRc4",
        authDomain: "pitch-f99af.firebaseapp.com",
        databaseURL: "https://pitch-f99af.firebaseio.com",
        storageBucket: "pitch-f99af.appspot.com",
        mynuskin: "https://www.mynuskin.com",
        clientId: "fdbd1a1070f44b90989418cd3d2e0ed8",
        clientSecret: "d9445b53123c4510A7CB6AF62D2E369E",
        simpleBeURL: "https://www.nuskin.com/simpleBe/api/v1/be",
        firebaseBeURL: "https://www.nuskin.com/simpleBe/api/v2/firebase/token"
    },
    stage: {
        apikey: "AIzaSyBnnPeo0fC99rVl8sItTX-9edBpx4oZEqk",
        authDomain: "stage-nuskin-9319a.firebaseapp.com",
        databaseURL: "https://stage-nuskin-9319a.firebaseio.com",
        storageBucket: "stage-nuskin-9319a.appspot.com",
        mynuskin:"https://www.mynuskin.com",
        clientId: "fdbd1a1070f44b90989418cd3d2e0ed8",
        clientSecret: "d9445b53123c4510A7CB6AF62D2E369E",
        simpleBeURL: "https://www.nuskin.com/simpleBe/api/v1/be",
        firebaseBeURL: "https://www.nuskin.com/simpleBe/api/v2/firebase/token"
    },
    test: {
        apiKey: "AIzaSyDqxHBk_XzYormp9s3pXw9tOKXzJdODWIk",
        authDomain: "testpitch-f0a71.firebaseapp.com",
        databaseURL: "https://testpitch-f0a71.firebaseio.com",
        storageBucket: "testpitch-f0a71.appspot.com",
        mynuskin: "https://test.mynuskin.com",
        clientId: "fdbd1a1070f44b90989418cd3d2e0ed8",
        clientSecret: "d9445b53123c4510A7CB6AF62D2E369E",
        simpleBeURL: "https://test.nuskin.com/simpleBe/api/v1/be",
        firebaseBeURL: "https://test.nuskin.com/simpleBe/api/v2/firebase/token"
    },
    dev: {
        apiKey: "AIzaSyDqxHBk_XzYormp9s3pXw9tOKXzJdODWIk",
        authDomain: "dev-storefront-1b640.firebaseio.com",
        databaseURL: "https://dev-storefront-1b640.firebaseio.com",
        storageBucket: "dev-storefront-1b640.appspot.com",
        mynuskin: "https://test.mynuskin.com",
        clientId: "fdbd1a1070f44b90989418cd3d2e0ed8",
        clientSecret: "d9445b53123c4510A7CB6AF62D2E369E",
        simpleBeURL: "https://test.nuskin.com/simpleBe/api/v1/be",
        firebaseBeURL: "https://test.nuskin.com/simpleBe/api/v2/firebase/token"
    }
};

let fbConfig;
let fb;
let environment;
let beUser;
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace FirebaseUtil
 */
let FirebaseUtil = {
    /**
     * Initializes firebase with the config for the correct database
     * @param app -- valid arguments: ("storefront", "ageloc")
     * @param _environment -- valid arguments: ("dev","test","prod")
     */
    init: function(_environment) {
        if (typeof(_environment) === 'undefined')
            _environment = 'dev';
        //TEMP FIX TO MAKE OLD VERSION OF PITCH APP WORK WHILE PASSING TWO PARAMETERS
        else if (_environment == 'storefront')
            _environment = 'test';

        environment = _environment;

        fbConfig = CONFIG[environment];
        if (firebase.apps.length > 0) {
            for (let i = 0; i < firebase.apps.length; i++) {
                if (fbConfig.databaseURL === firebase.apps[i].options.databaseURL) {
                    fb = firebase.apps[i];
                }
            }
            if (!fb)
                fb = firebase.initializeApp(fbConfig);
        }
        else
            fb = firebase.initializeApp(fbConfig);
    },
    /**
     * Returns the sapId for the passed in subdomain
     * @param subdomain
     */
    getSapIdFromDomain: function(subdomain) {
        let config = ConfigService.getMarketConfig();
        return $.ajax({url: config.storefrontUrl + "storefront/subdomains/" + subdomain + ".json"});
    },
    getPitchData: function(userId, pitchId) {
        let config = ConfigService.getMarketConfig();
        return $.ajax({url: config.storefrontUrl + "storefront/users/" + userId + "/pitches/" + pitchId + ".json"});
    },
    getUserData: function(userId) {
        let config = ConfigService.getMarketConfig();
        return $.ajax({url: config.storefrontUrl + "storefront/users/" + userId + ".json"});
    },
    getConfig: function() {
        return fbConfig;
    },
    getFB: function() {
        return fb;
    },
    /**
     * Retrieves Firebase auth token data given a username and password
     * @param username
     * @param password
     * @returns {Promise} Promise that resolves to Token object
     */
    getSignInToken: function(username, password) {
        let encodedAuthCredentials = Base64.encode(username + ":" + password),
            globalAuthUrl = util.getValue("nuskin.configuration.globalAuthUrl", fbConfig.simpleBeURL);

        return new Promise(function(resolve, reject) {
            $.ajax({
                url: globalAuthUrl,
                type: "GET",
                crossDomain: true,
                withCredentials: true,
                dataType: "json",
                beforeSend: function(xhr) {
                    xhr.setRequestHeader("Authorization", "Basic " + encodedAuthCredentials);
                    xhr.setRequestHeader("client_id", fbConfig.clientId);
                    xhr.setRequestHeader("client_secret", fbConfig.clientSecret);
                },
                success: function(result) {
                    beUser = result.businessEntity;
                    _getSignInTokenWithEid(beUser.encryptedId)
                        .then(function(token) {
                            token.name = beUser.name;
                            token.countryCd = beUser.countryCd;
                            token.customerType = beUser.customerType;
                            resolve(token);
                        })
                        .catch(reject);
                },
                error: function(xhr) {
                    console.log(xhr);
                    reject({error:true, reason: xhr});
                }
            });
        });
    },
    getSignInTokenWithEid: _getSignInTokenWithEid
};

/**
 * Retrieves Firebase auth token data for a given EID
 * @param eid
 * @returns {Promise} Promise that resolves to Token object
 * @private
 */
function _getSignInTokenWithEid(eid) {
    let firebaseTokenURL = fbConfig.firebaseBeURL + "/" + eid;

    return new Promise(function(resolve, reject) {
        $.ajax({
            url: firebaseTokenURL,
            type: "GET",
            crossDomain: true,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader("client_id", fbConfig.clientId);
                xhr.setRequestHeader("client_secret", fbConfig.clientSecret);
            },
            success: function (tokenResult) {
                if (tokenResult.Token) {
                    resolve(tokenResult.Token);
                } else
                    reject({error:true, reason: tokenResult});
            },
            error: function (xhr) {
                console.log(xhr);
                reject({error:true, reason: xhr});
            }
        });
    });
}

export default FirebaseUtil;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/firebaseUtil.js
// module id = 301
// module chunks = 0